import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL, COMPANY_EMAIL, whatsappLink, NAV_CATEGORIES } from "../data/constants";

export function Footer() {
  return (
    <footer className="navy-grid-bg mt-20 text-slate-300">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <Logo dark />
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Premium wholesale flooring & matting for dealers, distributors, contractors and projects.
              Factory-direct pricing, custom-cut dimensions.
            </p>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Explore</h4>
            <div className="mt-4 flex flex-col gap-2 text-sm">
              <Link to="/" className="hover:text-[#10B981]">Home</Link>
              <Link to="/about" className="hover:text-[#10B981]">About TFM</Link>
              <Link to="/catalogue" className="hover:text-[#10B981]">Products</Link>
              <Link to="/wholesale" className="hover:text-[#10B981]">Wholesale</Link>
              <Link to="/contact" className="hover:text-[#10B981]">Contact</Link>
            </div>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Categories</h4>
            <div className="mt-4 flex flex-col gap-2 text-sm">
              {NAV_CATEGORIES.map((c) => (
                <Link key={c} to={`/catalogue?category=${encodeURIComponent(c)}`} className="hover:text-[#10B981]">{c}</Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">Get in touch</h4>
            <div className="mt-4 flex flex-col gap-3 text-sm">
              <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-2 hover:text-[#10B981]">
                <Phone className="h-4 w-4 text-[#10B981]" /> {PHONE_DISPLAY}
              </a>
              <a href={`mailto:${COMPANY_EMAIL}`} className="flex items-center gap-2 break-all hover:text-[#10B981]">
                <Mail className="h-4 w-4 text-[#10B981]" /> {COMPANY_EMAIL}
              </a>
              <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#10B981]">
                <MessageCircle className="h-4 w-4 text-[#10B981]" /> Chat on WhatsApp
              </a>
              <span className="flex items-start gap-2 text-slate-400">
                <MapPin className="mt-0.5 h-4 w-4 text-[#10B981]" /> Guwahati, India
              </span>
            </div>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row">
          <p>© {new Date().getFullYear()} The Future Marketing. All rights reserved.</p>
          <p>Quality • Trust • Growth</p>
        </div>
      </div>
    </footer>
  );
}
